import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { QuestionBase } from '../../../../../patrol-template-management/controls/question-base';
import { PatrolSheetService } from '../../../../../service/patrol-sheet.service';

@Component({
  selector: 'app-job-patrol-sheet',
  templateUrl: './job-patrol-sheet.component.html',
  styleUrls: ['./job-patrol-sheet.component.less']
})
export class JobPatrolSheetComponent implements OnInit {

  @Input() groupId: number;
  @Input() jobId: number;
  @Input() formDisabled = false;
  equipments = [];
  controls = [];
  equipment: any = {};
  questions: QuestionBase<string>[] | null = [];
  form!: FormGroup;
  templateform!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private patrolSheetService: PatrolSheetService) { }

  ngOnInit(): void {
    this.patrolSheetService.getPatrolSheetsByJobIdAndgroupId(this.jobId, this.groupId).subscribe((data) => {
      if (!this.isEmpty(data)){
        this.equipments = JSON.parse(data[0].sheetContent).equipments;
        this.equipment = this.equipments[0];
      }
    });
  }
  click(item){
    this.controls = item.controls;
    this.equipment = item;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
